// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.devbox-log[data-v-40299e10] {
  width: 600px;
  max-height: 400px;
  overflow: auto;
  background: rgba(0, 0, 0, 0.5);
  color: #c9c9c9;
  padding: 12px;
  font-family: monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/pages/CreateDevbox.vue","webpack://./CreateDevbox.vue"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;ACDF","sourcesContent":["@import \"@bloglovin/vue-component-library/breakpoint-mixin.scss\";\n\r\n.devbox-log {\r\n  width: 600px;\r\n  max-height: 400px;\r\n  overflow: auto;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  color: #c9c9c9;\r\n  padding: 12px;\r\n  font-family: monospace;\r\n  font-size: 12px;\r\n  white-space: pre-wrap;\r\n  word-break: break-all;\r\n  border-radius: 4px;\r\n}\r\n",".devbox-log {\n  width: 600px;\n  max-height: 400px;\n  overflow: auto;\n  background: rgba(0, 0, 0, 0.5);\n  color: #c9c9c9;\n  padding: 12px;\n  font-family: monospace;\n  font-size: 12px;\n  white-space: pre-wrap;\n  word-break: break-all;\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
